'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setPostSuspended = setPostSuspended;
exports.postMessage = postMessage;
exports.clearMessages = clearMessages;
var SET_POST_SUSPENDED = exports.SET_POST_SUSPENDED = 'frame.setPostSuspended';
var POST_MESSAGE = exports.POST_MESSAGE = 'frame.postMessage';
var CLEAR_MESSAGES = exports.CLEAR_MESSAGES = 'frame.clearMessages';

/**
 * Nastaví pozastavení zpracování zpráv ve frontě.
 * @param area oblast
 * @param suspended zda je zpracování pozastaveno
 */
function setPostSuspended(area, suspended) {
    return {
        type: SET_POST_SUSPENDED,
        area: area,
        suspended: suspended
    };
}

/**
 * Poslání zprávy do frame.
 * @param area oblast
 * @param message message pro poslání
 */
function postMessage(area, message) {
    return {
        type: POST_MESSAGE,
        area: area,
        message: message
    };
}

/**
 * Smazání všech zpráv ve store, volá se např. po jejich odeslání komponentou.
 * @param area oblast
 */
function clearMessages(area) {
    return {
        type: CLEAR_MESSAGES,
        area: area
    };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZnJhbWUvRnJhbWVBY3Rpb25zLmpzeCJdLCJuYW1lcyI6WyJzZXRQb3N0U3VzcGVuZGVkIiwicG9zdE1lc3NhZ2UiLCJjbGVhck1lc3NhZ2VzIiwiU0VUX1BPU1RfU1VTUEVOREVEIiwiUE9TVF9NRVNTQUdFIiwiQ0xFQVJfTUVTU0FHRVMiLCJhcmVhIiwic3VzcGVuZGVkIiwidHlwZSIsIm1lc3NhZ2UiXSwibWFwcGluZ3MiOiI7Ozs7O1FBU2dCQSxnQixHQUFBQSxnQjtRQWFBQyxXLEdBQUFBLFc7UUFZQUMsYSxHQUFBQSxhO0FBbENULElBQU1DLGtEQUFxQix3QkFBM0I7QUFDQSxJQUFNQyxzQ0FBZSxtQkFBckI7QUFDQSxJQUFNQywwQ0FBaUIscUJBQXZCOztBQUVQOzs7OztBQUtPLFNBQVNMLGdCQUFULENBQTBCTSxJQUExQixFQUFnQ0MsU0FBaEMsRUFBMkM7QUFDOUMsV0FBTztBQUNIQyxjQUFNTCxrQkFESDtBQUVIRyxrQkFGRztBQUdIQztBQUhHLEtBQVA7QUFLSDs7QUFFRDs7Ozs7QUFLTyxTQUFTTixXQUFULENBQXFCSyxJQUFyQixFQUEyQkcsT0FBM0IsRUFBb0M7QUFDdkMsV0FBTztBQUNIRCxjQUFNSixZQURIO0FBRUhFLGtCQUZHO0FBR0hHO0FBSEcsS0FBUDtBQUtIOztBQUVEOzs7O0FBSU8sU0FBU1AsYUFBVCxDQUF1QkksSUFBdkIsRUFBNkI7QUFDaEMsV0FBTztBQUNIRSxjQUFNSCxjQURIO0FBRUhDO0FBRkcsS0FBUDtBQUlIIiwiZmlsZSI6IkZyYW1lQWN0aW9ucy5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBTRVRfUE9TVF9TVVNQRU5ERUQgPSAnZnJhbWUuc2V0UG9zdFN1c3BlbmRlZCc7XG5leHBvcnQgY29uc3QgUE9TVF9NRVNTQUdFID0gJ2ZyYW1lLnBvc3RNZXNzYWdlJztcbmV4cG9ydCBjb25zdCBDTEVBUl9NRVNTQUdFUyA9ICdmcmFtZS5jbGVhck1lc3NhZ2VzJztcblxuLyoqXG4gKiBOYXN0YXbDrSBwb3phc3RhdmVuw60genByYWNvdsOhbsOtIHpwcsOhdiB2ZSBmcm9udMSbLlxuICogQHBhcmFtIGFyZWEgb2JsYXN0XG4gKiBAcGFyYW0gc3VzcGVuZGVkIHpkYSBqZSB6cHJhY292w6Fuw60gcG96YXN0YXZlbm9cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIHNldFBvc3RTdXNwZW5kZWQoYXJlYSwgc3VzcGVuZGVkKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgICAgdHlwZTogU0VUX1BPU1RfU1VTUEVOREVELFxuICAgICAgICBhcmVhLFxuICAgICAgICBzdXNwZW5kZWQsXG4gICAgfTtcbn1cblxuLyoqXG4gKiBQb3Nsw6Fuw60genByw6F2eSBkbyBmcmFtZS5cbiAqIEBwYXJhbSBhcmVhIG9ibGFzdFxuICogQHBhcmFtIG1lc3NhZ2UgbWVzc2FnZSBwcm8gcG9zbMOhbsOtXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBwb3N0TWVzc2FnZShhcmVhLCBtZXNzYWdlKSB7XG4gICAgcmV0dXJuIHtcbiAgICAgICAgdHlwZTogUE9TVF9NRVNTQUdFLFxuICAgICAgICBhcmVhLFxuICAgICAgICBtZXNzYWdlLFxuICAgIH1cbn1cblxuLyoqXG4gKiBTbWF6w6Fuw60gdsWhZWNoIHpwcsOhdiB2ZSBzdG9yZSwgdm9sw6Egc2UgbmFwxZkuIHBvIGplamljaCBvZGVzbMOhbsOtIGtvbXBvbmVudG91LlxuICogQHBhcmFtIGFyZWEgb2JsYXN0XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBjbGVhck1lc3NhZ2VzKGFyZWEpIHtcbiAgICByZXR1cm4ge1xuICAgICAgICB0eXBlOiBDTEVBUl9NRVNTQUdFUyxcbiAgICAgICAgYXJlYSxcbiAgICB9XG59XG4iXX0=